import { Redirect } from 'expo-router';
import { useSQLiteContext } from 'expo-sqlite';
import { useEffect, useState } from 'react';
import { View } from 'react-native';

import { Palette } from '@/constants/theme';

/**
 * Boot screen. Checks SQLite for a completed property setup and routes
 * either into the main tabs or into onboarding. Renders a solid sand
 * background while deciding so there's no flash of empty white.
 */
export default function Boot() {
  const db = useSQLiteContext();
  const [target, setTarget] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const row = await db.getFirstAsync<{ n: number }>(
        'SELECT COUNT(*) AS n FROM property WHERE setup_complete = 1 AND deleted_at IS NULL'
      );
      if (cancelled) return;
      // Brand-new installs land on the /start landing page (Wave 58)
      // — expectations first, questions second.
      setTarget((row?.n ?? 0) > 0 ? '/(tabs)' : '/(onboarding)/start');
    })();
    return () => {
      cancelled = true;
    };
  }, [db]);

  if (!target) {
    return <View style={{ flex: 1, backgroundColor: Palette.sand }} />;
  }
  return <Redirect href={target as never} />;
}
